<lcs-loading-overlay [show]="callState$ | async | lcsCallState : 'loading'">
  <div mat-dialog-title class="dialog-header">
    <h3 class="dialog-title">{{ title }}</h3>
    <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
  </div>
  <form [formGroup]="form" (ngSubmit)="onConfirm()">
    <mat-dialog-content>
      <mat-form-field class="flex-half">
        <mat-label>DND Status</mat-label>
        <input
          matInput
          type="text"
          [value]="dndStatus"
          formControlName="dndStatus"
          id="extension-phone-dnd-status"
          />
          @if (form.get('dndStatus')?.hasError('maxlength')) {
            <mat-error>
              DND Status name cannot be more than 50 characters long. </mat-error
              >
            }@if (form.get('dndStatus')?.hasError('pattern') || form.get('dndStatus')?.hasError('whitespace')) {
            <mat-error
              >
              DND Status cannot contain leading/trailing spaces.
            </mat-error>
          }
        </mat-form-field>
      </mat-dialog-content>
      <mat-dialog-actions>
        <button type="submit" title="Confirm" mat-raised-button>OK</button>
        <button type="button" title="Cancel" mat-stroked-button (click)="onCloseClick()">Cancel</button>
      </mat-dialog-actions>
    </form>
  </lcs-loading-overlay>
